import { Component, ElementRef, inject, input, OnInit, viewChild } from '@angular/core';
import { FormGroup, NgControl } from '@angular/forms';
import { RemoveAsteriskPipe } from '@core/pipes';

@Component({
  selector: 'oke-form-input',
  templateUrl: './form-input.html',
  styleUrl: './form-input.scss',
  imports: [RemoveAsteriskPipe]
})
export class FormInput implements OnInit {
  private readonly _$inputElement = viewChild.required<ElementRef<HTMLInputElement>>('input');
  readonly $type = input('text', { alias: 'type' });
  readonly $view = input('', { alias: 'view' });
  readonly $label = input.required<string>({ alias: 'label' });
  readonly $form = input<FormGroup>(undefined, { alias: 'form' });
  readonly controlDir = inject(NgControl, { self: true });
  private _onChange: (value: string) => void = () => undefined;
  private _onTouched: () => void = () => undefined;

  //@Self Decorator uses angular dependency injection to grab current control value when component is initialized
  constructor() {
    this.controlDir.valueAccessor = this;
  }

  ngOnInit(): void {
    const control = this.controlDir.control;
    const validators = control?.validator ? [control.validator] : [];

    // const asyncValidators = control.asyncValidator ? [control.asyncValidator] : [];

    control?.setValidators(validators);
    // control.setAsyncValidators(asyncValidators);
    control?.updateValueAndValidity();
  }

  onChangeValue(value: string): void {
    this._onChange(value);
  }

  onTouchedValue(): void {
    this._onTouched();
  }

  //gives control value accessor access to the input feild value
  writeValue(value: string | null): void {
    this._$inputElement().nativeElement.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }
}
